import axios from "axios";

const secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";

let axiosInstance = axios.create({
    baseURL: `${secure}${process.env.VUE_APP_ENDPOINT_SERVICES_PLACES}`,
    timeout: 10000,
});

export function getPlacesByQuery(query, country = 'ro') {
    return axiosInstance.get('/api/search', {params: {query, country}})
        .catch(error => { console.log(error); });
}